import 'css-chunksrc/client/scenes/planzoneResourceToProject/resourceToProjectForm/roleSelection/styles.scss';export default {
  "roleSelection": "_roleSelection_1dawd_1",
  "input": "_input_1dawd_5",
  "inputOpened": "_inputOpened_1dawd_18",
  "selection": "_selection_1dawd_32",
  "placeholder": "_placeholder_1dawd_38",
  "list": "_list_1dawd_42",
  "role": "_role_1dawd_1",
  "iconBox": "_iconBox_1dawd_66",
  "icon": "_icon_1dawd_66",
  "iconReverse": "_iconReverse_1dawd_76",
  "opened": "_opened_1dawd_82",
  "selectedRole": "_selectedRole_1dawd_91",
  "selectedRoleIcon": "_selectedRoleIcon_1dawd_95",
  "selectedRoleTitle": "_selectedRoleTitle_1dawd_101",
  "roleDescription": "_roleDescription_1dawd_108"
};